export const APPROVAL_AMOUNT =
  "115792089237316195423570985008687907853269984665640564039457584007913129639935";

export const HALBORN_AUDIT_LINK =
  "https://staderlabs.com/docs/bnb/StaderLabs%20BnbX%20Smart%20Contrac%20Audit%20Report%20by%20Halborn.pdf";

export const PECKSHIELD_AUDIT_LINK =
  "https://github.com/stader-labs/audits/blob/main/peckshield/PeckShield-Audit-Report-Stader-Binance.pdf";

export const IMMUNEFI_LINK = "https://immunefi.com/bounty/staderforbnb/";

export const CERTORA_LINK =
  "https://vaas-stg.certora.com/output/49230/42cd6d302a1e25808222?anonymousKey=37ccba11c98b6af400271afdb6c5012ac0ae2d9d";
export const FORTA_LINK = "https://app.forta.network/agents/stader-labs";
